var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubrosLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "180.000000pt",
    height: "180.000000pt",
    viewBox: "0 0 180.000000 180.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,180.000000) scale(0.100000,-0.100000)",
    fill: "#FFFFFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M746 1719 c-22 -5 -42 -12 -45 -14 -2 -3 79 -5 180 -4 167 1 180 2 144 14 -46 15 -220 18 -279 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564 1645 c-17 -13 19 -14 310 -15 292 0 328 2 310 15 -28 21 -591 22 -620 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477 1583 c-4 -3 -7 -10 -7 -15 0 -4 180 -8 401 -8 316 0 400 3 397 13 -4 9 -93 13 -395 15 -214 1 -392 -1 -396 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411 1504 c-54 -68 -88 -190 -76 -273 10 -72 58 -162 118 -218 75 -71 124 -95 432 -208 180 -66 262 -126 285 -211 45 -161 -99 -286 -315 -272 -155 10 -273 127 -291 289 l-7 59 -135 0 -135 0 7 -77 c8 -92 42 -194 86 -263 l32 -50 478 0 479 0 25 52 c37 77 49 149 43 253 -9 151 -70 256 -201 343 -80 53 -106 65 -341 147 -212 73 -263 104 -285 170 -28 84 47 189 157 221 67 20 166 15 231 -11 53 -22 106 -83 127 -146 l17 -49 134 0 c134 0 134 0 134 23 0 39 -40 149 -72 200 l-30 47 -438 0 -439 0 -20 -26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460 225 c19 -23 841 -23 860 0 11 13 -38 15 -430 15 -392 0 -441 -2 -430 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554 155 c29 -22 643 -22 672 0 17 13 -22 14 -336 14 -314 0 -353 -1 -336 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710 84 c70 -22 189 -28 276 -14 144 23 123 29 -101 29 -206 0 -217 -1 -175 -15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubrosLogo);
export default __webpack_public_path__ + "static/media/subros_logo.104c9e46c8d6b8c811b47ce24ed12a5a.svg";
export { ForwardRef as ReactComponent };